<div class="encabezado">
  <!-- Header -->
  <div>
    <div>
      <div>
        <h5 class="titulo1">{{ "communication.inbox.title" | translate }}</h5>
      </div>
    </div>
  </div>

  <!-- Folder tabs -->
  <div class="folder-tabs">
    <button class="folder-tab" [class.active]="currentFolder === 'inbox'" (click)="switchFolder('inbox')">
      <i class="icon-envelope"></i>
      {{ "communication.inbox.folder_inbox" | translate }}
    </button>
    <button class="folder-tab" [class.active]="currentFolder === 'sent'" (click)="switchFolder('sent')">
      <i class="icon-paper-plane"></i>
      {{ "communication.inbox.folder_sent" | translate }}
    </button>
  </div>

  <!-- Filter row -->
  <div class="row mb-3">
    <div class="col-8">
      <div class="inbox-search-row">
        <div class="search-input-wrap">
          <i class="icon-magnifier"></i>
          <input type="text" class="form-control search-input"
            [ngModel]="searchTerm"
            (ngModelChange)="onSearchInput($event)"
            (keydown)="onSearchKeydown($event)"
            [placeholder]="'communication.inbox.search_placeholder' | translate">
          <button class="search-clear-btn" *ngIf="searchTerm" (click)="clearSearch()">
            <i class="icon-cross"></i>
          </button>
        </div>
        <label class="search-body-check" *ngIf="searchTerm">
          <input type="checkbox" [(ngModel)]="searchBody">
          <span>{{ "communication.inbox.search_body" | translate }}</span>
        </label>
        <button class="btn btn-secundario filter-btn" [class.active]="filterUnseen" (click)="toggleUnseen()"
          *ngIf="currentFolder === 'inbox'">
          <i class="icon-envelope-open"></i>
          <span class="filter-btn-text">{{ "communication.inbox.unread" | translate }}</span>
        </button>
        <button class="btn btn-secundario filter-btn" (click)="onRefresh()" [title]="'communication.inbox.refresh' | translate">
          <i class="icon-refresh"></i>
        </button>
      </div>
    </div>
    <div class="col-4">
      <div class="inbox-actions-row">
        <span class="pagination-info" *ngIf="meta.total > 0">
          {{ meta.from }}-{{ meta.to }} {{ "communication.inbox.of" | translate }} {{ meta.total }}
        </span>
      </div>
    </div>
  </div>

  <!-- Not configured state -->
  <div class="not-configured-state" *ngIf="notConfigured">
    <i class="icon-warning"></i>
    <p>{{ "communication.inbox.not_configured" | translate }}</p>
  </div>

  <!-- Content: list + detail/thread -->
  <div class="inbox-split" [class.detail-open]="selectedMessage || showThread || isLoadingDetail" *ngIf="!notConfigured">
    <!-- Email list -->
    <div class="inbox-list-panel">
      <div class="email-list" *ngIf="!isLoading">
        <div class="email-item" *ngFor="let msg of messages"
          [class.unread]="!msg.seen && !isOpened(msg)"
          [class.selected]="selectedUid === msg.uid && selectedFolder === (msg.folder || currentFolder)"
          (click)="selectMessage(msg)">

          <div class="email-content">
            <div class="email-top-row">
              <span class="email-sender" [class.fw-semibold]="!msg.seen && !isOpened(msg)">{{ getDisplayName(msg) }}</span>
              <span class="email-date">{{ formatDate(msg.date) }}</span>
            </div>
            <div class="email-address" *ngIf="getDisplayEmail(msg)">{{ getDisplayEmail(msg) }}</div>
            <div class="email-subject" [class.fw-semibold]="!msg.seen && !isOpened(msg)">{{ msg.subject || '(' + ("communication.inbox.no_subject" | translate) + ')' }}</div>
            <div class="email-meta">
              <span class="badge text-draft me-1" *ngIf="msg.has_attachments">
                <i class="icon-paperclip"></i>
              </span>
              <span class="badge bg-soft-primary me-1" *ngIf="!msg.seen && currentFolder === 'inbox'">
                <i class="icon-envelope"></i> {{ "communication.inbox.new" | translate }}
              </span>
              <span class="badge bg-soft-sent me-1" *ngIf="currentFolder === 'sent'">
                <i class="icon-paper-plane"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="empty-state" *ngIf="messages.length === 0">
          <i class="icon-inbox"></i>
          <p *ngIf="!searchTerm">{{ "communication.inbox.empty" | translate }}</p>
          <p *ngIf="searchTerm">{{ "communication.inbox.no_results" | translate }}</p>
        </div>
      </div>

      <div class="loading-state" *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="loading-hint" *ngIf="isSearching && searchBody">{{ "communication.inbox.search_body_slow" | translate }}</p>
      </div>

      <!-- Pagination -->
      <div class="inbox-pagination" *ngIf="!isLoading">
        <select class="form-control page-size-select" [ngModel]="perPage" (ngModelChange)="onPerPageChange($event)">
          <option *ngFor="let opt of perPageOptions" [ngValue]="opt">{{ opt }}</option>
        </select>
        <button class="btn btn-sm btn-hover" [disabled]="currentPage <= 1" (click)="goToPage(currentPage - 1)">
          <i class="icon-chevron-left"></i>
        </button>
        <span class="pagination-current">{{ currentPage }} / {{ meta.last_page }}</span>
        <button class="btn btn-sm btn-hover" [disabled]="currentPage >= meta.last_page" (click)="goToPage(currentPage + 1)">
          <i class="icon-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- Thread Panel -->
    <div class="inbox-detail-panel" *ngIf="showThread && threadMessages.length > 1">
      <div class="thread-container">
        <div class="thread-header">
          <div class="getBack" (click)="closeDetail()" style="cursor:pointer; margin-bottom:0;">
            <i class="icon-arrow-left"></i>
            <span>{{ "buttons.back" | translate }}</span>
          </div>
          <span class="thread-count">{{ threadMeta?.count }} {{ "communication.inbox.messages_in_thread" | translate }}</span>
        </div>
        <div class="thread-scroll-area">
          <div class="thread-message" *ngFor="let tmsg of threadMessages; let i = index"
            [class.thread-sent]="tmsg.folder === 'sent'"
            [class.thread-received]="tmsg.folder === 'inbox'">
            <div class="thread-message-header" (click)="toggleThreadMsg(tmsg)">
              <div class="sender-avatar-sm">{{ getFromDisplay(tmsg.from).charAt(0).toUpperCase() }}</div>
              <div class="thread-message-info">
                <span class="thread-sender">{{ getFromDisplay(tmsg.from) }}</span>
                <span class="thread-email" *ngIf="tmsg.from && tmsg.from.length > 0">{{ tmsg.from[0].email }}</span>
                <span class="thread-date">{{ formatDate(tmsg.date) }}</span>
              </div>
              <span class="badge bg-soft-sent" *ngIf="tmsg.folder === 'sent'">
                <i class="icon-paper-plane"></i>
              </span>
              <i [class]="isThreadMsgExpanded(tmsg) ? 'icon-chevron-up' : 'icon-chevron-down'" class="thread-toggle"></i>
            </div>
            <div class="thread-message-body" *ngIf="isThreadMsgExpanded(tmsg)">
              <div class="detail-attachments" *ngIf="tmsg.attachments && tmsg.attachments.length > 0">
                <div class="attachments-header">
                  <i class="icon-paperclip"></i>
                  {{ tmsg.attachments.length }} {{ "communication.inbox.attachments" | translate }}
                </div>
              </div>
              <div class="thread-body-html" [innerHTML]="tmsg.body_html || tmsg.body_text || ''"></div>
            </div>
          </div>
        </div>
        <!-- Reply from thread: reply to last inbox message -->
        <div class="thread-reply-area" *ngIf="getLastInboxMessage()">
          <app-inbox-detail
            [message]="getLastInboxMessage()!"
            [folder]="'inbox'"
            [compactMode]="true"
            (close)="closeDetail()"
            (replySent)="onReplySent()">
          </app-inbox-detail>
        </div>
      </div>
    </div>

    <!-- Single Detail Panel -->
    <div class="inbox-detail-panel" *ngIf="selectedMessage && !showThread">
      <app-inbox-detail
        [message]="selectedMessage"
        [folder]="selectedFolder"
        (close)="closeDetail()"
        (replySent)="onReplySent()">
      </app-inbox-detail>
    </div>

    <!-- Loading detail -->
    <div class="inbox-detail-panel detail-loading" *ngIf="isLoadingDetail && !selectedMessage && !showThread">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</div>
